// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedCategories-module__root___sW3Ls","breadcrumb":"RelatedCategories-module__breadcrumb___xriNN","breadcrumbItem":"RelatedCategories-module__breadcrumbItem___cb4ye"};